import * as React from 'react'

import { X } from 'lucide-react'
import { observer } from 'mobx-react'

import TwoMonthsDatePicker from '~/client/src/desktop/components/TwoMonthsDatePicker/TwoMonthsDatePicker'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import StruxhubInput from '~/client/src/shared/components/StruxhubInputs/StruxhubInput'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import ClosuresDatePickerStore from './ClosuresDatePicker.store'
import ProjectClosingInterval from './ProjectClosingInterval'

interface IProps {
  store: ClosuresDatePickerStore
  className?: string
}

@observer
export default class ClosuresDatePicker extends React.Component<IProps> {
  public render() {
    // These renderers are invoked inside TwoMonthsDatePicker's own reactive
    // render, and mobx-react refuses to hand out one observer's `props` from
    // another's derivation. Read the store here — in this component's render —
    // and pass it down, rather than reaching for `this.props` at call time.
    const { store, className } = this.props

    return (
      <TwoMonthsDatePicker
        store={store}
        className={className}
        customHeaderRenderer={() => this.renderHeader(store)}
        customFooterRenderer={() => this.renderFooter(store)}
      />
    )
  }

  private renderHeader = (store: ClosuresDatePickerStore) => {
    const { titleTranslatorKey, hide, intevalName, onIntevalNameChange } = store
    return (
      <div className="row pb10 mb20 bb-light-grey y-center">
        <div className="text bold uppercase extra-large">
          {titleTranslatorKey && Localization.getText(titleTranslatorKey)}
        </div>
        <StruxhubInput
          label={Localization.translator.closureName}
          onChange={onIntevalNameChange}
          value={intevalName}
        />
        <div className="ml15 no-grow">
          <Button variant="ghost" size="icon" onClick={hide}>
            <X />
          </Button>
        </div>
      </div>
    )
  }

  private renderFooter = (store: ClosuresDatePickerStore) => {
    const { onApplyClick, hide, onRemove, project } = store

    return (
      <div>
        <div className="tw:flex tw:justify-end">
          <Button variant="default" onClick={onApplyClick}>
            {Localization.translator.save}
          </Button>
        </div>
        <div className="tm-dp-btn-container col">
          <div className="full-width large text bold-font bb-light-input-border">
            {Localization.translator.customProjectClosures}
          </div>
          <div className="closing-intervals-holder full-width">
            {project?.closedIntervals &&
              project.closedIntervals.map((interval, idx) => (
                <ProjectClosingInterval
                  key={idx}
                  item={project}
                  interval={interval}
                  onRemove={onRemove}
                />
              ))}
          </div>
        </div>

        <div className="tm-dp-btn-container">
          <Button variant="ghost" className="tw:ml-auto" onClick={hide}>
            {Localization.translator.close}
          </Button>
        </div>
      </div>
    )
  }
}
